import {
  EXPLORE_LEGEND_ORDER,
  EXPLORE_PIN_COLORS,
  EXPLORE_PIN_LABELS,
} from "@/web/routes/_protected/smb/-dashboard/-actions/-explore/types";

/** Color key for the Explore map pins, overlaid in a corner of the map. */
export function ExploreLegend() {
  return (
    <div className="flex flex-col gap-1 bg-withus-pure-white/90 p-2 text-xs shadow-sm">
      {EXPLORE_LEGEND_ORDER.map((key) => (
        <div key={key} className="flex items-center gap-2">
          <span
            className="size-2.5 shrink-0 border border-[#1a1a1a]"
            style={{ backgroundColor: EXPLORE_PIN_COLORS[key] }}
          />
          <span className="text-withus-dark-blue">{EXPLORE_PIN_LABELS[key]}</span>
        </div>
      ))}
    </div>
  );
}
